/**
 * "Open in" of a pass in Executions (CU-869fmm944, decision 2, UX Obs. 8): DOR and LOR in a new tab with the pass
 * already chosen. Disabled with its reason while no search of the pass has finished — the same rule the analyzer
 * applies (`push.searches_finished`, gate 2 C3); unknown (`null`, the count could not be read) is not disabled.
 */
export const OPEN_IN_PATHS = { dor: '/analyzers/dor', lor: '/analyzers/lor' }

export function openInHref(analyzer, run) {
	const params = new URLSearchParams({ idRepricingExecution: run.execution_id })
	// the offices with a finished search (`push.offices_finished`, webback 0.89.0): one → the analyzer opens on it
	const offices = run.push?.offices_finished || []
	if (offices.length === 1) params.set('idOfficePickup', String(offices[0]))
	return `${OPEN_IN_PATHS[analyzer]}?${params.toString()}`
}

export function openInDisabledReason(run) {
	const finished = run?.push?.searches_finished
	if (finished === 0) return 'No prices yet: no search of this pass has finished'
	return null
}

export const openInTitle = analyzer => `Open this pass in the ${analyzer.toUpperCase()} Analyzer (new tab)`
